import React from "react";

const Disclamer = () => {
  return (
    <div className="px-2 text-center w-full text-[0.6rem] sm:text-[0.7rem] lg:text-[0.6rem] xl:text-xs text-gray-800 absolute bottom-0 pb-0 bg-white/40  z-[10] pointer-events-none">
      This 3D view is intellectual property of Air Brick Infra Pvt. Ltd. &
      cannot be used without consent of authorised authority. Note: this 3D is
      just for visualization, actual will be as per site and in 2D drawings.
    </div>
  );
};

export default Disclamer;
